// Store functionality
import getters from './getters';
import mutations from './mutations';
import actions from './actions';

const state = {
  count: 1,
  next: null,
  previous: null,
  results: [],
  mpInvitationNextPage: '',
  newMPInvitationCount: 0,
  newNotifsCount: 0,
  allNotifsCount: 0,
  newNotifications: [],
  readNotifications: [],
  allNotifications: [],
  currentNotification: {},
};

const store = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default store;
